import React from 'react';
import ChatIcon from './assets/chat_24.svg';
import styles from './index.module.scss';

export default function ChatBubbleButton({ onClick, ariaLabel }) {
  return (
    <button className={styles.bubble} onClick={onClick} aria-label={ariaLabel}>
      <ChatIcon className={styles.icon} />
    </button>
  );
}
